export { AtnReportListComponent as Component } from './page.component'
